import React, {PropTypes} from 'react';

const UserFormInput = ({
	input,
  label,
  meta: {error, submitFailed}, 
	type
}) => {
  let inputClass = 'form-control';
  let wrapperClass = 'row';
  if(error && submitFailed) {
    inputClass += ' form-control-danger';
    wrapperClass += ' has-danger';
  }
  
  return (
    <div className={wrapperClass}>
      <label htmlFor={input.name} className="col-lg-2 col-sm-3 col-form-label">{label}</label>
      <div className="col-lg-10 col-sm-9">
        <input {...input} 
                type={type} 
                className={inputClass}
        />
      {error && submitFailed && <div className="form-control-feedback">{error}</div>}
      </div>
    </div>
  );
};

UserFormInput.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired
};

export default UserFormInput;


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/UserFormInput.js
 **/